import type { HostInstitution } from "@classes-service-types/host-institution";
import type { HostInstitutionResponseSchema } from "@classes-service-types/host-institution-response-schema";
import { useQuery } from "@tanstack/vue-query";
import type { AxiosResponse } from "axios";
import { computed, type Ref, unref } from "vue";
import hostInstitutionService from "@/services/hostInstitution";

export const useGetHostInstitutionById = (hostInstitutionId: Ref<string> | string) => {
  const enabled = computed(() => Boolean(unref(hostInstitutionId)));
  const queryKey = computed(() => ["get-host-institution-by-id", unref(hostInstitutionId)]);

  return useQuery<HostInstitution, Error, HostInstitution>({
    enabled: enabled,
    queryKey: queryKey,
    queryFn: async (): Promise<HostInstitution> => {
      const response: AxiosResponse<HostInstitutionResponseSchema> =
        await hostInstitutionService.getHostInstitutionById(unref(hostInstitutionId));
      return response.data.data.items;
    },
  });
};
